import { useEffect, useState } from 'react';

import Loader from '../components/loader/Loader';
import AlertMessage from '../components/alerts/AlertMessage';
import SwitchInput from '../components/inputs/SwitchInput';
import { useNotifications } from '../store/notifications/hooks';
import { NOTIFICATION_TYPE_DESCRIPTIONS, NOTIFICATION_TYPE_LABELS, NOTIFICATION_TYPE_ORDER } from '../core/constants';

const Notifications = () => {
  const { preferences, loading, getNotificationPreferences, updateNotificationPreference } = useNotifications();
  const [feedbackError, setFeedbackError] = useState('');

  useEffect(() => {
    getNotificationPreferences();
  }, [getNotificationPreferences]);

  const handleToggle = (type) => async (enabled) => {
    const result = await updateNotificationPreference({ type, enabled });
    if (result?.error) {
      setFeedbackError('Failed to update your notification preferences. Please try again.');
    }
  };

  const isInitialLoading = loading && Object.keys(preferences).length === 0;

  return (
    <div className="w-full space-y-6">
      <h1 className="text-h3">Email Notifications</h1>

      <div className="max-w-4xl rounded-xl bg-white-100 p-8">
        <p className="mb-6 text-lg text-gray-800">
          Choose which email notifications you’d like to receive. Changes are saved automatically.
        </p>

        {isInitialLoading ? (
          <Loader />
        ) : (
          <ul className="divide-y divide-gray-100" data-testid="notification-preferences">
            {NOTIFICATION_TYPE_ORDER.map((type) => (
              <li key={type} className="flex items-center justify-between gap-4 py-4">
                <div>
                  <p className="text-base font-semibold text-gray-950">{NOTIFICATION_TYPE_LABELS[type]}</p>
                  <p className="text-sm text-gray-600">{NOTIFICATION_TYPE_DESCRIPTIONS[type]}</p>
                </div>
                <SwitchInput
                  id={`notification-${type}`}
                  label=""
                  checked={preferences[type] ?? true}
                  onChange={handleToggle(type)}
                />
              </li>
            ))}
          </ul>
        )}
      </div>

      <AlertMessage
        open={!!feedbackError}
        message={feedbackError || 'Oops, something went wrong!'}
        onClose={() => setFeedbackError('')}
        severity="error"
      />
    </div>
  );
};

export default Notifications;
